import React from 'react';

/**
 * Allow the user to name the supported Flow service that they have selected for install
 * @param {Object} newServiceData = {} - Object containing all the data about the new service being created
 * @param {Function} setNewServiceDetails = {} - Function on ServiceController that allows us to update the newServiceData
 */
const NewFlowService = ({ newServiceData, setNewServiceDetails }) => (
    <>
        <h1>{`New ${newServiceData.selectedServiceView} Service`}</h1>
        <h4>{newServiceData.description}</h4>
        <label>
            Name: 
            <span className="input-required"> *</span>
        </label>
        <input
            className="form-control"
            onChange={({ target }) => setNewServiceDetails(target.value, 'name')}
            value={newServiceData.name}
            required
        />
        <label>Url: </label>
        <input
            className="form-control"
            value={newServiceData.url}
            disabled
        />
    </>
);

export default NewFlowService;
